export default __webpack_public_path__ + "static/media/focus-on-cores-desktop.bffa0ad8.png";